var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("div", [
          _c("p", {
            staticClass: "icon-jujue closeBtn",
            on: { click: _vm.routerBack },
          }),
        ]),
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-row",
              { attrs: { type: "flex", align: "middle" } },
              [
                _vm.statusView == "S"
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "acl",
                            rawName: "v-acl",
                            value: _vm.RMC_PROT_3P_SUBMIT,
                            expression: "RMC_PROT_3P_SUBMIT",
                          },
                        ],
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.submitData("detailInfo")
                          },
                        },
                      },
                      [_vm._v("提交")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _vm._m(0),
            _c(
              "el-form",
              {
                ref: "detailInfo",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.detailInfo,
                  rules: _vm.rules,
                  "label-position": _vm.labelPosition,
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "年份", prop: "year" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: _vm.statusView == "S" ? false : true,
                                "value-format": "yyyy",
                                type: "year",
                                placeholder: "选择年",
                              },
                              on: { change: _vm.yearChange },
                              model: {
                                value: _vm.detailInfo.year,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "year", $$v)
                                },
                                expression: "detailInfo.year",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Protein ASL",
                              prop: "rmcProteinAslId",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.statusView == "S" &&
                                    !_vm.$route.query.id
                                      ? false
                                      : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.detailInfo.rmcProteinAslId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailInfo,
                                      "rmcProteinAslId",
                                      $$v
                                    )
                                  },
                                  expression: "detailInfo.rmcProteinAslId",
                                },
                              },
                              _vm._l(
                                _vm.aslGroupCodeList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.code,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Sponsor" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.detailInfo.sponsorName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "sponsorName", $$v)
                                },
                                expression: "detailInfo.sponsorName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "审核类型", prop: "auditType" } },
                          [
                            _c("ic-select", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: _vm.$route.query.id ? true : false,
                                table: "TT_RMC_PROTEIN_AUDIT_REPORT",
                                filterable: "",
                                field: "AUDIT_TYPE",
                                clearable: "",
                              },
                              on: { change: _vm.getType },
                              model: {
                                value: _vm.detailInfo.auditType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "auditType", $$v)
                                },
                                expression: "detailInfo.auditType",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Category3",
                              prop: "category3Code",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.statusView == "S" ? false : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                on: { change: _vm.getCategory3Name },
                                model: {
                                  value: _vm.detailInfo.category3Code,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailInfo,
                                      "category3Code",
                                      $$v
                                    )
                                  },
                                  expression: "detailInfo.category3Code",
                                },
                              },
                              _vm._l(_vm.category3List, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.object,
                                    value: item.key,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "GMP",
                              prop: "gmp",
                              rules: {
                                required: _vm.isGmpMust,
                                message: "请选择GMP",
                                trigger: "change",
                              },
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.statusView == "S" ? false : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.detailInfo.gmp,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detailInfo, "gmp", $$v)
                                  },
                                  expression: "detailInfo.gmp",
                                },
                              },
                              _vm._l(_vm.gradeList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.name, value: item.code },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "HACCP",
                              prop: "haccp",
                              rules: {
                                required: _vm.isMust,
                                message: "请选择HACCP",
                                trigger: "change",
                              },
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.statusView == "S" ? false : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.detailInfo.haccp,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detailInfo, "haccp", $$v)
                                  },
                                  expression: "detailInfo.haccp",
                                },
                              },
                              _vm._l(_vm.gradeList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.name, value: item.code },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Antibiotics",
                              prop: "antibiotics",
                              rules: {
                                required:
                                  _vm.isMust &&
                                  _vm.detailInfo.category3Code != "10103"
                                    ? true
                                    : false,
                                message: "请选择Antibiotics",
                                trigger: "change",
                              },
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.statusView == "S" ? false : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.detailInfo.antibiotics,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detailInfo, "antibiotics", $$v)
                                  },
                                  expression: "detailInfo.antibiotics",
                                },
                              },
                              _vm._l(_vm.gradeList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.name, value: item.code },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "AnimalWalfare",
                              prop: "animalWalfare",
                              rules: {
                                required: _vm.isMust,
                                message: "请选择AnimalWalfare",
                                trigger: "change",
                              },
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.statusView == "S" ? false : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.detailInfo.animalWalfare,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailInfo,
                                      "animalWalfare",
                                      $$v
                                    )
                                  },
                                  expression: "detailInfo.animalWalfare",
                                },
                              },
                              _vm._l(_vm.gradeList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.name, value: item.code },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "ASL审核时间",
                              prop: "aslAuditDate",
                              rules: {
                                required:
                                  _vm.detailInfo.auditType ==
                                  "SECOND_PARTY_VERIFY_REPORT"
                                    ? true
                                    : _vm.isMust
                                    ? true
                                    : false,
                                message: "请选择ASL审核时间",
                                trigger: "change",
                              },
                            },
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: _vm.statusView == "S" ? false : true,
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                placeholder: "选择日期",
                              },
                              on: { change: _vm.changeDate },
                              model: {
                                value: _vm.detailInfo.aslAuditDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "aslAuditDate", $$v)
                                },
                                expression: "detailInfo.aslAuditDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: `${_vm.customLabel}`,
                              prop: "swa",
                              rules: {
                                required: _vm.isMust1,
                                message: "请选择" + _vm.customLabel,
                                trigger: "change",
                              },
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.statusView == "S" ? false : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.detailInfo.swa,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detailInfo, "swa", $$v)
                                  },
                                  expression: "detailInfo.swa",
                                },
                              },
                              _vm._l(_vm.swaList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.name, value: item.code },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: `${_vm.customLabel}审核时间`,
                              prop: "swaAuditDate",
                            },
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: _vm.statusView == "S" ? false : true,
                                "value-format": "yyyy-MM-dd",
                                type: "date",
                                placeholder: "选择日期",
                              },
                              on: { change: _vm.changeSwaDate },
                              model: {
                                value: _vm.detailInfo.swaAuditDate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "swaAuditDate", $$v)
                                },
                                expression: "detailInfo.swaAuditDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "备注" } },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                autosize: { minRows: 2, maxRows: 4 },
                                disabled: _vm.statusView == "S" ? false : true,
                                maxlength: "1000",
                                "show-word-limit": "",
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailInfo.remark,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "remark", $$v)
                                },
                                expression: "detailInfo.remark",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "handle-box", staticStyle: { "margin-top": "20px" } },
          [
            _vm._m(1),
            _c(
              "el-row",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "flex", align: "middle" },
              },
              [
                _c(
                  "el-col",
                  {
                    staticStyle: {
                      height: "100%",
                      display: "flex",
                      "align-items": "center",
                    },
                    attrs: { span: 12 },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "acl",
                            rawName: "v-acl",
                            value: _vm.RMC_PROT_3P_UPLOAD,
                            expression: "RMC_PROT_3P_UPLOAD",
                          },
                        ],
                        attrs: {
                          size: "small",
                          type: "primary",
                          disabled: _vm.detailInfo.auditType ? false : true,
                        },
                        on: { click: _vm.openFile },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("common.selectFile")) + " ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-table",
              {
                ref: "plxTable",
                staticStyle: { "margin-top": "10px" },
                attrs: {
                  data: _vm.fileList,
                  "max-height": "500",
                  "show-overflow": "ellipsis",
                  "highlight-current-row": "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: "附件类型",
                    align: "center",
                    prop: "userName",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_c("span", [_vm._v(_vm._s(scope.row.isType))])]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "文件名称",
                    prop: "documentName",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.onDownload(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(scope.row.documentName))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "文件描述",
                    align: "center",
                    prop: "docComments",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: scope.row.isDescribe,
                                placement: "top-start",
                              },
                            },
                            [_c("span", [_vm._v(_vm._s(scope.row.isDescribe))])]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "上传人", align: "center", prop: "userName" },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "上传时间",
                    align: "center",
                    prop: "createDate",
                  },
                }),
                _vm.statusView == "S"
                  ? _c("el-table-column", {
                      attrs: {
                        label: "操作",
                        align: "center",
                        prop: "updateDate",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("i", {
                                  staticClass: "el-icon-delete",
                                  staticStyle: { color: "red" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.delFile(
                                        scope.row,
                                        scope.$index
                                      )
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        384807566
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "提示",
              visible: _vm.dialogVisible,
              width: "30%",
              "before-close": _vm.handleClose,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
            },
          },
          [
            _vm.dialogVisible
              ? _c("uploadFile", {
                  attrs: {
                    detailInfo: _vm.detailInfo,
                    tsReckindId: _vm.tsReckindId,
                  },
                  on: { close: _vm.handleClose },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "info_box_title",
        staticStyle: { "padding-left": "10px", "box-sizing": "border-box" },
      },
      [
        _c("p", { staticClass: "line" }),
        _c("p", { staticClass: "info_title" }, [_vm._v("ASL审核")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "info_box_title",
        staticStyle: { "padding-left": "10px", "box-sizing": "border-box" },
      },
      [
        _c("p", { staticClass: "line" }),
        _c("p", { staticClass: "info_title" }, [_vm._v("附件")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }